
import WordDialog, { AddWordDialog } from './components/commonWords/addWord_dialog.vue'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { AppModule } from '@/store/modules/app'
import { CommonService } from '@/services'
import { word } from '@/types/common-types'

@Component({
    name: 'common-words',
    components: {
        WordDialog
    }
})
export default class extends Vue {
    @Ref('wordDialogRef') private wordDialog!: AddWordDialog
    private pageSize = 15
    private pageIndex = 1
    private pageTotal = 0
    private isLoading = false
    private curWord: word = { id: 0, content: '' }
    get commonWords() {
        return AppModule.commonWords
    }

    private onPageChange(curPage: number) {
        this.pageIndex = curPage
    }

    /** 新增常用语 */
    private async onAddWord(content: string) {
        const params = { content }
        const result = await CommonService.createCommonWord(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '新增成功',
                showClose: true
            })
            this.wordDialog.hide()
            this.isLoading = true
            await AppModule.getCommonWords()
            this.isLoading = false
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    /** 删除常用语 */
    private async deleteWord(word: word) {
        const params = { id: word.id }
        const result = await CommonService.deleteCommonWord(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '删除成功',
                showClose: true
            })
            const list = [...this.commonWords]
            list.splice(list.indexOf(word), 1)
            AppModule.setCommonWords(list)
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }

    private onDeleteWord(word: word) {
        this.$confirm('是否确认删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            this.deleteWord(word)
        })        
    }

    private onUpdateWord(word: word) {
        this.curWord = word
        this.wordDialog.show(word.content, 'update')
    }

    /** 修改常用语 */
    private async updateWord(content: string) {
        if (!this.curWord.id) return
        const params = {
            id: this.curWord.id,
            content: content
        }
        const result = await CommonService.updateCommonWord(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            this.wordDialog.hide()
            this.curWord.content = content
            return
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误, 请稍后再试',
            showClose: true
        })
    }
}
